export default {
  ACCESSIBILITY: {
    icon: 'accessibility_new',
  },
  FORMAT_STRIKETHROUGH: {
    icon: 'strikethrough_s',
  },
  FORMAT_CLEAR: {
    icon: 'format_clear',
  },
  BORDER_COLOR: {
    icon: 'border_color',
  },
  TITLE: {
    icon: 'title',
  },
  ADD_CHART: {
    icon: 'add_chart',
  },
  ANALYTICS: {
    icon: 'analytics',
  },
  ACCOUNT_CIRCLE: {
    icon: 'account_circle',
  },
  ACCOUNT_TREE: {
    icon: 'account_tree',
  },
  NEST_MULTI_ROOMS: {
    icon: 'nest_multi_room',
  },
  STOREFRONT: {
    icon: 'storefront',
  },
  ADD_BUSINESS: {
    icon: 'add_business',
  },
  ADD_BOX: {
    icon: 'add_box',
  },
  ADD_CIRCLE: {
    icon: 'add_circle',
  },
  ADD_CIRCLE_OUTLINED: {
    icon: 'add_circle_outline',
  },
  ADMIN_PANEL_SETTINGS: {
    icon: 'admin_panel_settings',
  },
  ANGLE_DOWN: {
    icon: 'keyboard_arrow_down',
  },
  ANGLE_LEFT: {
    icon: 'keyboard_arrow_left',
  },
  ANGLE_RIGHT: {
    icon: 'keyboard_arrow_right',
  },
  ANGLE_UP: {
    icon: 'keyboard_arrow_up',
  },
  ANIMATION: {
    icon: 'animation',
  },
  APARTMENT: {
    icon: 'apartment',
  },
  APPS: {
    icon: 'apps',
  },
  ARCHIVE: {
    icon: 'inventory_2',
  },
  ARROW_BACK: {
    icon: 'arrow_back',
  },
  ARROW_CIRCLE_DOWN: {
    icon: 'arrow_circle_down',
  },
  ARROW_CIRCLE_UP: {
    icon: 'arrow_circle_up',
  },
  ARROW_DOWNWARD: {
    icon: 'arrow_downward',
  },
  ARROW_DROP_DOWN: {
    icon: 'arrow_drop_down',
  },
  ARROW_FORWARD: {
    icon: 'arrow_forward',
  },
  ARROW_LEFT: {
    icon: 'arrow_back',
  },
  ARROW_RIGHT: {
    icon: 'arrow_forward',
  },
  ARROW_UPWARD: {
    icon: 'arrow_upward',
  },
  ARTICLE: {
    icon: 'article',
  },
  ASSIGNMENT_IND: {
    icon: 'assignment_ind',
  },
  ASSIGNMENT_TURNED_IN: {
    icon: 'assignment_turned_in',
  },
  ASSISTANT: {
    icon: 'assistant',
  },
  ASSISTANT_DIRECTION: {
    icon: 'assistant_direction',
  },
  ASTERISK: {
    icon: 'error',
  },
  AT: {
    icon: 'alternate_email',
  },
  ATTACH_FILE: {
    icon: 'attach_file',
  },
  AUTO_AWESOME: {
    icon: 'auto_awesome',
  },
  BADGE: {
    icon: 'badge',
  },
  BELL: {
    icon: 'notifications',
  },
  BLOCK: {
    icon: 'block',
  },
  BOLT: {
    icon: 'BOLT',
  },
  MOVE_LOCATION: {
    icon: 'move_location',
  },
  OVERVIEW_KEY: {
    icon: 'overview_key',
  },
  BOOKMARK: {
    icon: 'bookmark',
  },
  BOOKMARK_BORDER: {
    icon: 'bookmark_border',
  },
  BOOK: {
    icon: 'book_5',
  },
  BUBBLE_CHART: {
    icon: 'bubble_chart',
  },
  BULLET: {
    icon: 'fiber_manual_record',
  },
  BUSINESS: {
    icon: 'business_center',
  },
  CALCULATOR: {
    icon: 'calculate',
  },
  CALENDAR: {
    icon: 'calendar_today',
  },
  CALENDAR_TODAY: {
    icon: 'calendar_today',
  },
  CALENDAR_CLOCK: {
    icon: 'calendar_clock',
  },
  CALENDAR_VIEW_DAY: {
    icon: 'calendar_view_day',
  },
  CALL_MERGE: {
    icon: 'call_merge',
  },
  CAMERA_RETRO: {
    icon: 'photo_camera',
  },
  CAMPAIGN: {
    icon: 'campaign',
  },
  CANCEL: {
    icon: 'cancel',
  },
  CARET_DOWN: {
    icon: 'arrow_drop_down',
  },
  CARET_UP: {
    icon: 'arrow_drop_up',
  },
  CAST_FOR_EDUCATION: {
    icon: 'cast_for_education',
  },
  CATEGORY: {
    icon: 'category',
  },
  CATEGORY_SEARCH: {
    icon: 'category_search',
  },
  CHANGE_CIRCLE: {
    icon: 'change_circle',
  },
  CHAT: {
    icon: 'chat',
  },
  CHAT_BUBBLE_OUTLINE: {
    icon: 'chat_bubble_outline',
  },
  CHECK: {
    icon: 'check',
  },
  CHECKBOX: {
    icon: 'check_box_outline_blank',
  },
  CHECKBOX_SELECTED: {
    icon: 'check_box',
  },
  CHECKLIST: {
    icon: 'checklist',
  },
  CHECK_CIRCLE: {
    icon: 'check_circle',
  },
  CHEVRON_DOWN: {
    icon: 'keyboard_arrow_down',
  },
  CHEVRON_LEFT: {
    icon: 'keyboard_arrow_left',
  },
  CHEVRON_RIGHT: {
    icon: 'keyboard_arrow_right',
  },
  CHEVRON_UP: {
    icon: 'keyboard_arrow_up',
  },
  CIRCLE: {
    icon: 'brightness_1',
  },
  CLEAR: {
    icon: 'clear',
  },
  CLIPBOARD: {
    icon: 'copy_all',
  },
  CLOCK: {
    icon: 'schedule',
  },
  CLOSE: {
    icon: 'close',
  },
  CLOUD_DONE: {
    icon: 'cloud_done',
  },
  CLOUD_DOWNLOAD: {
    icon: 'cloud_download',
  },
  CLOUD_OFF: {
    icon: 'cloud_off',
  },
  CLOUD_UPLOAD: {
    icon: 'cloud_upload',
  },
  COG: {
    icon: 'settings',
  },
  COLLECTIONS_BOOKMARK: {
    icon: 'collections_bookmark',
  },
  CONNECT_WITHOUT: {
    icon: 'connect_without_contact',
  },
  CONTACT_PAGE: {
    icon: 'contact_page',
  },
  CONTENT_COPY: {
    icon: 'content_copy',
  },
  CONTENT_PASTE: {
    icon: 'content_paste',
  },
  COPY: {
    icon: 'file_copy',
  },
  CROP_FREE: {
    icon: 'crop_free',
  },
  CURRENCY: {
    icon: 'monetization_on',
  },
  DATA_OBJECT: {
    icon: 'data_object',
  },
  DESCRIPTION: {
    icon: 'description',
  },
  DESKTOP_WINDOWS: {
    icon: 'desktop_windows',
  },
  DIRECTIONS: {
    icon: 'directions',
  },
  DOMAIN: {
    icon: 'domain',
  },
  DONE: {
    icon: 'done',
  },
  DONE_ALL: {
    icon: 'done_all',
  },
  DOUBLE_ANGLE_DOWN: {
    icon: 'keyboard_double_arrow_down',
  },
  DOUBLE_ANGLE_LEFT: {
    icon: 'keyboard_double_arrow_left',
  },
  DOUBLE_ANGLE_RIGHT: {
    icon: 'keyboard_double_arrow_right',
  },
  DOUBLE_ANGLE_UP: {
    icon: 'keyboard_double_arrow_up',
  },
  DOUBLE_ARROW: {
    icon: 'double_arrow',
  },
  DOWNLOAD_BOTTOM_BAR: {
    icon: 'vertical_align_bottom',
  },
  DRAG_INDICATOR: {
    icon: 'drag_indicator',
  },
  EDIT: {
    icon: 'edit',
  },
  EDITOR_CHOICE: {
    icon: 'military_tech',
  },
  EDIT_SQUARE: {
    icon: 'edit_square',
  },
  EMAIL: {
    icon: 'email',
  },
  ENGINEERING: {
    icon: 'engineering',
  },
  ENVELOPE: {
    icon: 'mail',
  },
  EXTENSION: {
    icon: 'extension',
  },
  ERROR: {
    icon: 'error',
  },
  EXCLAMATION: {
    icon: 'priority_high',
  },
  EXCLAMATION_MARK: {
    icon: 'error',
  },
  EXPAND: {
    icon: 'expand_more',
  },
  EXPAND_CONTENT: {
    icon: 'expand_content',
  },
  EXPLORE: {
    icon: 'explore',
  },
  EYE: {
    icon: 'remove_red_eye',
  },
  FACE: {
    icon: 'face',
  },
  FACT_CHECK: {
    icon: 'fact_check',
  },
  FILE: {
    icon: 'insert_drive_file',
  },
  FILE_COPY: {
    icon: 'file_copy',
  },
  FILE_DOWNLOAD: {
    icon: 'sim_card_download',
  },
  FILE_UPLOAD: {
    icon: 'file_upload',
  },
  FILTER: {
    icon: 'filter_list',
  },
  FILTER_ALT: {
    icon: 'filter_alt',
  },
  FILTER_LIST: {
    icon: 'filter_list',
  },
  FILTER_LIST_OFF: {
    icon: 'filter_list_off',
  },
  FIND_IN_PAGE: {
    icon: 'find_in_page',
  },
  FINGERPRINT: {
    icon: 'fingerprint',
  },
  FLAG: {
    icon: 'flag',
  },
  FOLDER: {
    icon: 'folder',
  },
  FORK_RIGHT: {
    icon: 'fork_right',
  },
  FORMAT_QUOTE: {
    icon: 'format_quote',
  },
  FORMAT_BOLD: {
    icon: 'format_bold',
  },
  FORMAT_ITALIC: {
    icon: 'format_italic',
  },
  FORMAT_UNDERLINED: {
    icon: 'format_underlined',
  },
  FORMAT_LIST_BULLETED: {
    icon: 'format_list_bulleted',
  },
  FORMAT_LIST_NUMBERED: {
    icon: 'format_list_numbered',
  },
  FORMAT_ALIGN_LEFT: {
    icon: 'format_align_left',
  },
  FORMAT_ALIGN_CENTER: {
    icon: 'format_align_center',
  },
  FORMAT_ALIGN_RIGHT: {
    icon: 'format_align_right',
  },
  GET_APP: {
    icon: 'get_app',
  },
  GLOBE: {
    icon: 'public',
  },
  GPS: {
    icon: 'gps_fixed',
  },
  GRADUATION_CAP: {
    icon: 'school',
  },
  GRAPH: {
    icon: 'graph_3',
  },
  GRAPH_4: {
    icon: 'graph_4',
  },
  GRAPH_5: {
    icon: 'graph_5',
  },
  GROUP: {
    icon: 'group',
  },
  GROUPS: {
    icon: 'groups',
  },
  GROUP_ADD: {
    icon: 'group_add',
  },
  HAND: {
    icon: 'pan_tool',
  },
  HANDYMAN: {
    icon: 'handyman',
  },
  HEADSET: {
    icon: 'headset_mic',
  },
  HEADSET_MIC: {
    icon: 'headset_mic',
  },
  HEART: {
    icon: 'favorite',
  },
  HEART_OUTLINE: {
    icon: 'favorite_border',
  },
  HELP: {
    icon: 'help',
  },
  HELP_OUTLINE: {
    icon: 'help_outline',
  },
  HISTORY: {
    icon: 'history',
  },
  HOT: {
    icon: 'whatshot',
  },
  HOURGLASS_EMPTY: {
    icon: 'hourglass_empty',
  },
  HOURGLASS_FULL: {
    icon: 'hourglass_full',
  },
  HOW_TO_REG: {
    icon: 'how_to_reg',
  },
  HUB: {
    icon: 'hub',
  },
  IDEA: {
    icon: 'wb_incandescent',
  },
  IMPORT_CONTACTS: {
    icon: 'import_contacts',
  },
  INFO: {
    icon: 'info',
  },
  INSERT_CHART: {
    icon: 'insert_chart',
  },
  JOIN_LEFT: {
    icon: 'join_left',
  },
  JOIN_INNER: {
    icon: 'join_inner',
  },
  KEY: {
    icon: 'vpn_key',
  },
  LABEL: {
    icon: 'label',
  },
  LABEL_NEW: {
    icon: 'new_label',
  },
  LAN: {
    icon: 'lan',
  },
  LANGUAGE: {
    icon: 'translate',
  },
  LAPTOP_MAC: {
    icon: 'laptop_mac',
  },
  LAYERS: {
    icon: 'layers',
  },
  LIBRARY_ADD_CHECK: {
    icon: 'library_add_check',
  },
  LICENSE: {
    icon: 'license',
  },
  LIGHT_BULB: {
    icon: 'lightbulb',
  },
  LINE: {
    icon: 'horizontal_rule',
  },
  LINK: {
    icon: 'link',
  },
  LINK_OFF: {
    icon: 'link_off',
  },
  LIST: {
    icon: 'list',
  },
  LOCATION_OFF: {
    icon: 'location_off',
  },
  LOCK: {
    icon: 'lock',
  },
  LOCK_OPEN: {
    icon: 'lock_open',
  },
  LOGOUT: {
    icon: 'logout',
  },
  LOOP: {
    icon: 'loop',
  },
  MAGIC: {
    icon: 'auto_fix_high',
  },
  MAGIC_OFF: {
    icon: 'auto_fix_off',
  },
  MANAGE_SEARCH: {
    icon: 'manage_search',
  },
  MAP: {
    icon: 'map',
  },
  MAP_MARKER: {
    icon: 'place',
  },
  MAP_SEARCH: {
    icon: 'map_search',
  },
  MENU: {
    icon: 'menu',
  },
  MERGE: {
    icon: 'merge_type',
  },
  MINUS: {
    icon: 'remove',
  },
  MOBILE_PHONE: {
    icon: 'phone_iphone',
  },
  MODEL_TRAINING: {
    icon: 'model_training',
  },
  MONETIZATION_ON: {
    icon: 'monetization_on',
  },
  MOVE_FILE: {
    icon: 'drive_file_move',
  },
  NEXT: {
    icon: 'navigate_next',
  },
  OPEN_IN_NEW: {
    icon: 'open_in_new',
  },
  PAGEVIEW: {
    icon: 'pageview',
  },
  PAUSE: {
    icon: 'pause',
  },
  PAYMENTS: {
    icon: 'payments',
  },
  PENCIL: {
    icon: 'create',
  },
  PENDING: {
    icon: 'pending',
  },
  PEOPLE_SEARCH: {
    icon: 'person_search',
  },
  PERSON: {
    icon: 'person',
  },
  PERSON_ADD: {
    icon: 'person_add',
  },
  PERSON_PLAY: {
    icon: 'person_play',
  },
  PERSON_CHECK: {
    icon: 'person_check',
  },
  PHONE: {
    icon: 'phone',
  },
  PHONE_IPHONE: {
    icon: 'phone_iphone',
  },
  PHOTO: {
    icon: 'image',
  },
  PIE_CHART: {
    icon: 'pie_chart',
  },
  PIN: {
    icon: 'pin',
  },
  PLAY: {
    icon: 'play_arrow',
  },
  PLAYLIST: {
    icon: 'featured_play_list',
  },
  PLAY_CIRCLE: {
    icon: 'play_circle',
  },
  PLUS: {
    icon: 'add',
  },
  PDF: {
    icon: 'picture_as_pdf',
  },
  POLICY: {
    icon: 'policy',
  },
  POLYMER: {
    icon: 'polymer',
  },
  PSYCHOLOGY: {
    icon: 'psychology',
  },
  PUBLISHED_WITH_CHANGES: {
    icon: 'published_with_changes',
  },
  PUSH_PIN: {
    icon: 'push_pin',
  },
  QUESTION_MARK: {
    icon: 'question_mark',
  },
  QUESTION_MARK_OUTLINE: {
    icon: 'help_outline',
  },
  RADIO_BUTTON_UNCHECKED: {
    icon: 'radio_button_unchecked',
  },
  RECEIPT_LONG: {
    icon: 'receipt_long',
  },
  REMOVE_CIRCLE: {
    icon: 'remove_circle',
  },
  REMOVE_CIRCLE_OUTLINE: {
    icon: 'remove_circle_outline',
  },
  REPLAY: {
    icon: 'replay',
  },
  RECOMMEND: {
    icon: 'recommend',
  },
  REFRESH: {
    icon: 'refresh',
  },
  REPLY: {
    icon: 'reply',
  },
  RESTART_ALT: {
    icon: 'restart_alt',
  },
  ROUTE: {
    icon: 'route',
  },
  SAVE_ALT: {
    icon: 'save_alt',
  },
  SAVE: {
    icon: 'save',
  },
  SCHEDULE: {
    icon: 'schedule',
  },
  SCIENCE: {
    icon: 'science',
  },
  SEARCH: {
    icon: 'search',
  },
  SEARCH_FILE: {
    icon: 'plagiarism',
  },
  SEARCH_OFF: {
    icon: 'search_off',
  },
  SEGMENT: {
    icon: 'segment',
  },
  SEND: {
    icon: 'send',
  },
  SENSOR_OCCUPIED: {
    icon: 'sensor_occupied',
  },
  SETTINGS: {
    icon: 'settings',
  },
  SHARE: {
    icon: 'share',
  },
  SHOW_CHART: {
    icon: 'show_chart',
  },
  SIGNAL: {
    icon: 'signal_cellular_alt',
  },
  SKILLS: {
    icon: 'local_offer',
  },
  SMILEY_MEDIUM: {
    icon: 'sentiment_satisfied',
  },
  SMILEY_SAD: {
    icon: 'mood_bad',
  },
  SMILEY_SUPER_HAPPY: {
    icon: 'sentiment_very_satisfied',
  },
  SMART_TOY: {
    icon: 'smart_toy',
  },
  SMS_FAILED: {
    icon: 'sms_failed',
  },
  SORT: {
    icon: 'sort',
  },
  SORT_AZ: {
    icon: 'sort_by_alpha',
  },
  STAIRS: {
    icon: 'stairs',
  },
  SPEED: {
    icon: 'speed',
  },
  STAR: {
    icon: 'star',
  },
  STAR_EMPTY: {
    icon: 'star_border',
  },
  STAR_SHINE: {
    icon: 'star_shine',
  },
  STAT_3: {
    icon: 'stat_3',
  },
  STICKY_NOTE: {
    icon: 'sticky_note_2',
  },
  STOP: {
    icon: 'stop',
  },
  STOP_CIRCLE: {
    icon: 'stop_circle',
  },
  STORAGE: {
    icon: 'storage',
  },
  SUN: {
    icon: 'wb_sunny',
  },
  SUPERVISOR: {
    icon: 'supervisor_account',
  },
  SUPPORT_AGENT: {
    icon: 'support_agent',
  },
  SWAP_HORIZONTAL: {
    icon: 'swap_horiz',
  },
  SWITCH_LEFT: {
    icon: 'switch_left',
  },
  SYNC: {
    icon: 'sync',
  },
  SYNC_ALT: {
    icon: 'sync_alt',
  },
  TABLE: {
    icon: 'table_view',
  },
  TABLE_ROWS: {
    icon: 'table_rows',
  },
  TARGET: {
    icon: 'track_changes',
  },
  TARGET_NEW: {
    icon: 'target',
  },
  TASK: {
    icon: 'task',
  },
  TASK_ALT: {
    icon: 'task_alt',
  },
  TEXT_FIELDS: {
    icon: 'text_fields',
  },
  TEXT_FILE: {
    icon: 'text_snippet',
  },
  TEXT_FORMAT: {
    icon: 'text_format',
  },
  THREE_DOTS: {
    icon: 'more_horiz',
  },
  THREE_DOTS_VERTICAL: {
    icon: 'more_vert',
  },
  THUMBS_DOWN: {
    icon: 'thumb_down',
  },
  THUMBS_UP: {
    icon: 'thumb_up',
  },
  TIMER: {
    icon: 'timer',
  },
  TOGGLE_OFF: {
    icon: 'toggle_off',
  },
  TOGGLE_ON: {
    icon: 'toggle_on',
  },
  TRAFFIC: {
    icon: 'traffic',
  },
  TRANSLATE: {
    icon: 'translate',
  },
  TRASH: {
    icon: 'delete',
  },
  TRASH_OUTLINE: {
    icon: 'delete_outline',
  },
  TREND_DOWN: {
    icon: 'trending_down',
  },
  TREND_UP: {
    icon: 'trending_up',
  },
  TRIP: {
    icon: 'trip',
  },
  TROPHY: {
    icon: 'emoji_events',
  },
  TUNE: {
    icon: 'tune',
  },
  UNDO: {
    icon: 'undo',
  },
  UNFOLD_LESS: {
    icon: 'unfold_less',
  },
  UNFOLD_MORE: {
    icon: 'unfold_more',
  },
  UPLOAD_FILE: {
    icon: 'upload_file',
  },
  UPDATE: {
    icon: 'update',
  },
  USER: {
    icon: 'person',
  },
  USER_CIRCLE: {
    icon: 'account_circle',
  },
  VERTICAL_SPLIT: {
    icon: 'vertical_split',
  },
  VIDEO_CAM: {
    icon: 'videocam',
  },
  VIDEO_RECORD: {
    icon: 'video_call',
  },
  VIEW_COLUMN: {
    icon: 'view_column',
  },
  VIEW_GRID: {
    icon: 'view_module',
  },
  VIEW_LIST: {
    icon: 'view_list',
  },
  VISIBILITY: {
    icon: 'visibility',
  },
  VISIBILITY_OFF: {
    icon: 'visibility_off',
  },
  DRIVE_FILE_MOVE: {
    icon: 'drive_file_move',
  },
  VERIFIED_USER: {
    icon: 'verified_user',
  },
  VOLUNTEER_ACTIVISM: {
    icon: 'volunteer_activism',
  },
  WARNING: {
    icon: 'warning',
  },
  WARNING_AMBER: {
    icon: 'warning_amber',
  },
  WHATSHOT: {
    icon: 'whatshot',
  },
  WORK: {
    icon: 'work',
  },
  WORKSPACE_PREMIUM: {
    icon: 'workspace_premium',
  },
  WORK_OUTLINE: {
    icon: 'work_outline',
  },
  YOUTUBE_SEARCHED_FOR: {
    icon: 'youtube_searched_for',
  },
  ZOOM_OUT_MAP: {
    icon: 'zoom_out_map',
  },
  HORIZONTAL_RULE: {
    icon: 'horizontal_rule',
  },
  FLASH_ON: {
    icon: 'flash_on',
  },
  FLASH_OFF: {
    icon: 'flash_off',
  },
  PERSON_REMOVE: {
    icon: 'person_remove',
  },
  BAR_CHART: {
    icon: 'bar_chart',
  },
  ARROWS_UP: {
    icon: 'arrow_shape_up_stack_2',
  },
  MANAGE_ACCOUNTS: {
    icon: 'manage_accounts',
  },
  PERSON_SEARCH: {
    icon: 'person_search',
  },
  SIDE_NAVIGATION: {
    icon: 'side_navigation',
  },
  TEXT_SMS: {
    icon: 'textsms',
  },
  CHAT_ADD_ON: {
    icon: 'chat_add_on',
  },
  CACHED: {
    icon: 'cached',
  },
  NEXT_WEEK: {
    icon: 'next_week',
  },
  SHIELD_PERSON: {
    icon: 'shield_person',
  },
  SCREENSHOT: {
    icon: 'screenshot_frame_2',
  },
  DOCS: {
    icon: 'docs',
  },
  CROWN: {
    icon: 'crown',
  },
  EDIT_NOTE: {
    icon: 'edit_note',
  },
  ELECTRIC_BOLT: {
    icon: 'electric_bolt',
  },
  ADD_ALERT: {
    icon: 'add_alert',
  },
  PRIORITY: {
    icon: 'priority',
  },
  EVENT_NOTE: {
    icon: 'event_note',
  },
  CASES: {
    icon: 'cases',
  },
  HOME_REPAIR_SERVICE: {
    icon: 'home_repair_service',
  },
  EMERGENCY_HOME: {
    icon: 'emergency_home',
  },
  PEOPLE: {
    icon: 'people',
  },
  DASHBOARD: {
    icon: 'dashboard',
  },
  MENU_BOOK: {
    icon: 'menu_book',
  },
  ROCKET_LAUNCH: {
    icon: 'rocket_launch',
  },
  ADD_NOTES: {
    icon: 'add_notes',
  },
  TABLE_ROWS_NARROW: {
    icon: 'table_rows_narrow',
  },
  VIEW_COZY: {
    icon: 'view_cozy',
  },
  CABLE: {
    icon: 'cable',
  },
  BOOK_RIBBON: {
    icon: 'book_ribbon',
  },
  LEFT_PANEL_CLOSE: {
    icon: 'left_panel_close',
  },
  LEFT_PANEL_OPEN: {
    icon: 'left_panel_open',
  },
  WEB_ASSET: {
    icon: 'web_asset',
  },
  TOUCH_LONG: {
    icon: 'touch_long',
  },
  CONVERSION_PATH: {
    icon: 'conversion_path',
  },
  GPP_BAD: {
    icon: 'gpp_bad',
  },
  GPP_GOOD: {
    icon: 'gpp_good',
  },
};
